export const messages = {
  en: {
    regulationCategories: {
      search: {
        title: 'Search Condition',
        categoryName: 'categoryName',
        parentId: 'parentId',
        sortOrder: 'sortOrder',
        placeholder: 'Please enter regulationCategories name'
      },
      list: {
        title: 'regulationCategories List'
      },
      dialog: {
        addTitle: 'Add RegulationCategories',
        editTitle: 'Edit RegulationCategories',
        delTitle: 'Delete RegulationCategories',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        categoryId: 'categoryId',
        categoryName: 'categoryName',
        parentId: 'parentId',
        sortOrder: 'sortOrder',
      },
      table: {
        categoryId: 'categoryId',
        categoryName: 'categoryName',
        parentId: 'parentId',
        sortOrder: 'sortOrder',
      },
      validate: {
        categoryId: 'Please enter categoryId',
        categoryName: 'Please enter categoryName',
        sortOrder: 'Please enter sortOrder',
      },
      add: {
        success: 'Add RegulationCategories success'
      },
      edit: {
        success: 'Edit RegulationCategories success'
      },
      delete: {
        success: 'Delete RegulationCategories success',
        confirm: 'Are you sure to delete this regulationCategories?'
      },
      fetchError: 'Failed to fetch regulationCategories list'
    }
  },
  zh: {
    regulationCategories: {
      search: {
        title: '查询条件',
        categoryName: '分类名称',
        parentId: '父分类ID',
        sortOrder: '排序序号',
        placeholder: '请输入制度分类名称'
      },
      list: {
        title: '制度分类'
      },
      dialog: {
        addTitle: '添加制度分类',
        editTitle: '编辑制度分类',
        delTitle: '删除制度分类',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        categoryId: '分类ID',
        categoryName: '分类名称',
        parentId: '父分类ID',
        sortOrder: '排序序号',
      },
      table: {
        categoryId: '分类ID',
        categoryName: '分类名称',
        parentId: '父分类ID',
        sortOrder: '排序序号',
      },
      validate: {
        categoryId: '请输入分类ID',
        categoryName: '请输入分类名称',
        sortOrder: '请输入排序序号',
      },
      add: {
        success: '添加制度分类成功'
      },
      edit: {
        success: '编辑制度分类成功'
      },
      delete: {
        success: '删除制度分类成功',
        confirm: '确认删除该制度分类吗？'
      },
      fetchError: '获取制度分类列表失败'
    }
  },
  'zh-TW': {
    regulationCategories: {
      search: {
        title: '查詢條件',
        categoryName: '分類名稱',
        parentId: '父分類ID',
        sortOrder: '排序序號',
        placeholder: '請輸入制度分類名稱'
      },
      list: {
        title: '制度分類'
      },
      dialog: {
        addTitle: '添加制度分類',
        editTitle: '編輯制度分類',
        delTitle: '刪除制度分類',
        cancel: '取消',
        confirm: '確定'
      },
      form: {
        categoryId: '分類ID',
        categoryName: '分類名稱',
        parentId: '父分類ID',
        sortOrder: '排序序號',
      },
      table: {
        categoryId: '分類ID',
        categoryName: '分類名稱',
        parentId: '父分類ID',
        sortOrder: '排序序號',
      },
      validate: {
        categoryId: '請輸入分類ID',
        categoryName: '請輸入分類名稱',
        sortOrder: '請輸入排序序號',
      },
      add: {
        success: '添加制度分類成功'
      },
      edit: {
        success: '編輯制度分類成功'
      },
      delete: {
        success: '刪除制度分類成功',
        confirm: '確認刪除該制度分類嗎？'
      },
      fetchError: '獲取制度分類列表失敗'
    }
  }
}